<template>
    <RightSidebar v-if="!appData.isMobile">
    </RightSidebar>
    <RightSidebarMobile v-else>
         
    </RightSidebarMobile>
</template>
<script>
    import { reactive, toRefs, computed } from "vue";

    import { Constants } from "@/helpers/constants";
    import { appData, C } from "@/helpers/global";

    import RightSidebar from "@/layouts/_partials/RightSidebar.vue";
    import RightSidebarMobile from "@/layouts/_partials/RightSidebar.mobile.vue";

    import ProgressBar from "@/components/ProgressBar.vue";
    import NumericUpDown from "@/components/NumericUpDown.vue";

    import PreviewCard from "@/components/card/PreviewCard.vue";
    import NetAverage from "@/components/card/NetAverage.vue";
    import WeeklyWorkingTimeChart from "@/components/chart/WeeklyWorkingTimeChart.vue";

    export default {
        components: {
            RightSidebar,
            RightSidebarMobile,
            
            ProgressBar,
            NumericUpDown,

            PreviewCard,
            NetAverage,
            WeeklyWorkingTimeChart,
        },
        unmounted() { this.bus.leave(); },
        setup() {
            const e = reactive({
                bus: appData.eventBus([Constants.Key.RightSidebar, Constants.Key.RightSidebarSelected]),
                type: computed(() => {
                    return C.Int(e.bus.get(Constants.Key.RightSidebar)?.type);
                }),
                data: computed(() => {
                    return e.bus.get(Constants.Key.RightSidebar)?.data;
                }),
                selected(args) {
                    e.bus.set(Constants.Key.RightSidebarSelected, args);
                }
            });
            return { ...toRefs(e) };
        },
    };
</script>